module.exports = __webpack_public_path__ + "img/video.cda26dda.svg";